import { SyllabaryKatakanaHalfwidthIcon } from './SyllabaryKatakanaHalfwidthIcon';

/**
 * author: Haley Halcyon
 * id BEDFC0D3-5AC2-46E4-BD69-07048CC47710
 * name syllabary-katakana-halfwidth
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/syllabary-katakana-halfwidth.svg
 * tags
 * - Alpha / Numeric 
 */
export const WritingSystemKatakanaHalfWidthIcon = SyllabaryKatakanaHalfwidthIcon;
export default WritingSystemKatakanaHalfWidthIcon